<template>
  <div ref="wrapper" class="relative">
    <button
      type="button"
      class="w-full text-left rounded-lg border border-gray-300 bg-white px-3 py-2 text-base text-hk-dark focus:border-hk-red focus:ring-1 focus:ring-hk-red/20 focus:outline-none flex items-center justify-between"
      @click="open = !open"
    >
      <span>{{ selectedLabel }}</span>
      <svg
        class="w-4 h-4 text-hk-gray transition-transform"
        :class="open ? 'rotate-180' : ''"
        fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </button>
    <transition
      enter-active-class="transition ease-out duration-150"
      enter-from-class="opacity-0 -translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-in duration-100"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-1"
    >
      <ul
        v-if="open"
        class="absolute mt-1 w-full bg-white border border-hk-cream-dark/40 rounded-xl shadow-lg overflow-y-auto"
        style="z-index: 9999; max-height: 12.5rem;"
      >
        <li
          v-for="opt in options"
          :key="opt.value"
          class="px-4 py-2.5 text-sm text-hk-dark cursor-pointer transition-colors hover:bg-hk-cream"
          :class="opt.value === modelValue ? 'bg-hk-cream-dark font-semibold' : ''"
          @click="select(opt.value)"
        >
          {{ opt.label }}
        </li>
      </ul>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from "vue";

const props = defineProps<{
  modelValue: number | string;
  options: { value: number | string; label: string }[];
}>();

const emit = defineEmits<{
  (e: "update:modelValue", val: number | string): void;
}>();

const open = ref(false);
const wrapper = ref<HTMLElement | null>(null);

const selectedLabel = computed(() => {
  const found = props.options.find((o) => o.value === props.modelValue);
  return found ? found.label : "";
});

const select = (val: number | string) => {
  emit("update:modelValue", val);
  open.value = false;
};

const onClickOutside = (e: MouseEvent) => {
  if (wrapper.value && !wrapper.value.contains(e.target as Node)) {
    open.value = false;
  }
};

onMounted(() => document.addEventListener("click", onClickOutside));
onUnmounted(() => document.removeEventListener("click", onClickOutside));
</script>
